/*
  CHANGELOG
  Date: 2026-09-02
  Editor: Cord, via Perplexity Computer
  What changed: Normalized storefront links that the desktop Mega Menu app emits with the raw Shopify hostname.
  Where: assets/homepage-v2.js
  Rollback theme: BACKUP PRE Homepage V2 - Sep 2 2026 (180398686455)
*/

(function () {
  if (window.__hoogaHomepageV2Loaded) return;
  window.__hoogaHomepageV2Loaded = true;

  function track(element) {
    var eventName = element.getAttribute('data-hpv2-event');
    if (!eventName) return;

    var payload = { event: eventName };
    Array.prototype.forEach.call(element.attributes, function (attribute) {
      if (attribute.name.indexOf('data-hpv2-param-') !== 0) return;
      var key = attribute.name.replace('data-hpv2-param-', '').replace(/-/g, '_');
      payload[key] = attribute.value;
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function deviceCategory() {
    if (window.matchMedia('(max-width: 749px)').matches) return 'mobile';
    if (window.matchMedia('(max-width: 989px)').matches) return 'tablet';
    return 'desktop';
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-hpv2-event]');
    if (!target) return;
    if (!target.hasAttribute('data-hpv2-param-device-category')) {
      target.setAttribute('data-hpv2-param-device-category', deviceCategory());
    }
    if (!target.hasAttribute('data-hpv2-param-destination-url') && target.href) {
      target.setAttribute('data-hpv2-param-destination-url', target.href);
    }
    track(target);
  });

  function initHero(hero) {
    if (!hero || hero.getAttribute('data-hpv2-initialized') === 'true') return;
    var video = hero.querySelector('video');
    var button = hero.querySelector('[data-hpv2-video-toggle]');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!video || !button) return;
    hero.setAttribute('data-hpv2-initialized', 'true');

    function updateVideoControl() {
      var icon = button.querySelector('[data-hpv2-video-icon]');
      var isPaused = video.paused;
      button.setAttribute('aria-label', isPaused ? 'Play background video' : 'Pause background video');
      button.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
      if (icon) icon.textContent = isPaused ? '▶' : 'Ⅱ';
    }

    if (reducedMotion) {
      video.pause();
      button.hidden = true;
      return;
    }

    video.addEventListener('play', updateVideoControl);
    video.addEventListener('pause', updateVideoControl);
    video.addEventListener('error', function () {
      button.hidden = true;
    });
    updateVideoControl();

    button.addEventListener('click', function () {
      if (video.paused) {
        var playRequest = video.play();
        if (playRequest && typeof playRequest.catch === 'function') {
          playRequest.then(updateVideoControl).catch(updateVideoControl);
        } else {
          updateVideoControl();
        }
      } else {
        video.pause();
        updateVideoControl();
      }
    });
  }

  function initAllHeroes(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-hpv2-hero]'), initHero);
  }

  function normalizeStorefrontLink(link) {
    var sourceUrl;
    if (!link || !link.href) return;
    try {
      sourceUrl = new URL(link.href);
    } catch (error) {
      return;
    }
    if (sourceUrl.hostname !== 'hooga-health.myshopify.com') return;
    link.href = window.location.origin + sourceUrl.pathname + sourceUrl.search + sourceUrl.hash;
  }

  function normalizeStorefrontLinks(root) {
    Array.prototype.forEach.call(root.querySelectorAll('a[href]'), normalizeStorefrontLink);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllHeroes(document);
      normalizeStorefrontLinks(document);
      window.setTimeout(function () { normalizeStorefrontLinks(document); }, 1000);
      window.setTimeout(function () { normalizeStorefrontLinks(document); }, 3000);
    });
  } else {
    initAllHeroes(document);
    normalizeStorefrontLinks(document);
    window.setTimeout(function () { normalizeStorefrontLinks(document); }, 1000);
    window.setTimeout(function () { normalizeStorefrontLinks(document); }, 3000);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllHeroes(event.target);
    normalizeStorefrontLinks(document);
  });

  document.addEventListener('pointerover', function (event) {
    normalizeStorefrontLink(event.target.closest('a[href]'));
  }, true);

  document.addEventListener('click', function (event) {
    normalizeStorefrontLink(event.target.closest('a[href]'));
  }, true);

  if (window.MutationObserver) {
    var linkObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('a[href]')) normalizeStorefrontLink(node);
          if (node.querySelectorAll) normalizeStorefrontLinks(node);
        });
      });
    });
    linkObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
